/**
 * 程序配置项
 */

import store from '../store/store'
// console.warn("config> store:%o", store);
// 接口路径配置
// export const API_HOST = (process.env.NODE_ENV === 'production') ?
//     'http://box.bingofresh.com/api.php?s=' :
//     'http://t-box.bingofresh.com/Api'

export const MOCK_DEBUG = false;

// export const API_HOST = (MOCK_DEBUG === true) ?
//     '' : ((window.location.host === 'console.kx.qinghuafm.com')?
//     'http://api.kx.qinghuafm.com':'http://59.110.240.142:8080')
export const CONSOLE_HOST = (MOCK_DEBUG === true) ?
    '' : ((window.location.host === 'localhost:8000' || window.location.host === 'test.banma.jizhuoyangqing.com')?
    '//59.110.240.142:8080':'//be.banma.jizhuoyangqing.com:8080')//'http://console.kx.qinghuafm.com:8080')//'http://59.110.240.142:8080')
// console.debug("config>"+window.location.host);
export const API_HOST = (MOCK_DEBUG === true) ?
    '' : ((window.location.host === 'localhost:8000' || window.location.host === 'test.banma.jizhuoyangqing.com')?
    '//59.110.240.142:80':'//api.banma.jizhuoyangqing.com')

export const QUERY_HOST = (MOCK_DEBUG === true) ?
    '' : ((window.location.host === 'localhost:8000' || window.location.host === 'test.banma.jizhuoyangqing.com')?
    '//be.banma.jizhuoyangqing.com':'//be.banma.jizhuoyangqing.com')

// export const API_HOST = (window.location.host === 'console.kx.qinghuafm.com') ?
//     'http://59.110.240.142:8080' : ((MOCK_DEBUG === true)?
//     '':'')

// 配置接口token
export const TOKEN = store.getters.getToken
export const ACCOUNT = store.getters.getAccount

// 1：头条、2：时政、3：社会、4：国际、5：科技、6：财经、7：娱乐、8：体育、9：军事、10：时尚
export const newsType = {
    // "1": "头条",
    "2": "时政",
    "3": "社会",
    "4": "国际",
    "5": "科技",
    "6": "财经",
    "7": "娱乐",
    "8": "体育",
    "9": "军事",
    "10": "时尚",
}

export const hotsType = {
    "0": "头条",
    "1": "HOT 1",
    "2": "HOT 2",
    "3": "HOT 3",
    "4": "HOT 4",
    "5": "HOT 5",
    "6": "HOT 6",
    "7": "HOT 7"
}

export const newsPlatform = {
    "1": "腾讯新闻",
    "2": "新浪新闻",
    "3": "中新网",
    "4": "凤凰网",
    "5": "人民网",
    "6": "网易新闻",
    "7": "今日头条",
}

export const newsListAddr = [
    { "value": "腾讯新闻", "address": "qq.com" },
    { "value": "新浪新闻", "address": "sina.com.cn" },
    { "value": "中新网", "address": "chinanews.com" },
    { "value": "凤凰网", "address": "ifeng.com" },
    { "value": "人民网", "address": "people.com.cn/" },
    { "value": "网易新闻", "address": "163.com" },
    { "value": "今日头条", "address": "toutiao.com" }
]

export const newsPlatformType = {
    "腾讯新闻": "1",
    "百度新闻": "2"
}

export const auditType = {
    "1": "编辑端",
    "2": "录音端",
    "5": "回收站",
}

export const auditFullType = {
    "1": "编辑中",
    "2": "录音中",
    "3": "审核中",
    "4": "已发布",
    "5": "回收站",
    "6": "待发布",
}

export const roleType = {
    "": "unknown",
    "1": "ieditor",
    "2": "irecord",
    "3": "audit",
    "4": "stats",
    "5": "",
}
export const roleTypeId = {
    "ieditor": "1",
    "irecord": "2",
    "audit": "3",
    "stats": "4",
    "unknown": ""
}

export const searchOptions = {
    "标签": "1",
    "标题": "2",
    "内容": "4"
}

export const eventType = {
    "1": "增加新闻",
    "2": "编辑新闻",
    "3": "发布新闻",
    "4": "上传录音",
    "5": "发布录音",
    "6": "审核打回",
    "7": "审核通过",
    "8": "自动发布新闻",
}

export const routerType = {
    "ieditor": "编辑端",
    "irecord": "录音端",
    "audit": "审核端",
    "press": "班玛",
    "stats": "监控端",
}

// 接口参数配置
export function setParams(param) {
    // console.debug("setParams> TOKEN:%o, getToken:%o, ACCOUNT:%o, getAccount:%o", TOKEN, store.getters.getToken, ACCOUNT, store.getters.getAccount);
    var token = {
        token: store.getters.getToken,
        name: store.getters.getAccount
    }
    // console.debug("setParams> token:%o", token);
    var params = Object.assign(token, param)
    // console.debug("setParams> params:%o", params);
    return params
}

export const headerOption = {
    title : {
      text: '新闻产出分布',
      subtext: '',
      x: 'center',
      align: 'right'
    },
    toolbox: {
        show : true,
        feature : {
          dataZoom: {
              yAxisIndex: 'none'
          },
          dataView: {
              show: true,
              readOnly: false
          },
          magicType: {
              show: false,
              type: ["bar"]
          },
          restore: {
              show: false
          },
          saveAsImage: {
              show: true
          }
        }
    },
    legend: {
        data:['新闻数量'],
        x: 'left'
    },
    tooltip : {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            animation: false,
            label: {
                backgroundColor: '#505765'
            }
        }
    },
    dataZoom: {
        show: true,
        realtime: true,
        start : 0,//8
    },
    grid: {
        y2: 80
    },
    xAxis : [
        {
          type : 'time',
          splitNumber:6
        }
    ],
    yAxis : [
        {
          name: '数量(条/每小时)',
          type : 'value'
        }
    ],
    series : [
        {
            name: '新闻数量',
            type: 'line',
            showAllSymbol: true,
            data: null,
        }
    ]

}



// WEBPACK FOOTER //
// ./src/config/config.js